<template>
  <section class="announce-wrapper" v-if="text">
    <img src="./images/announce.svg" />
    <span>{{ text }}</span>
  </section>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import * as Request from '@/assets/request';

  const text = ref('');

  const getText = async () => {
    const result = await Request.post({
      url: '/22001/facade/notice/global/announcements'
    });
    if(result?.code != 200) return;

    text.value = result.data?.content || '';
  }
  onMounted(() => {
    getText();
  })
</script>

<style scoped lang="less">
@import "./index.less";
</style>
